/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";

import { ChangeMobileFormat,randomStringOnlyNumber,sendMessageToMobile } from "../../components/common/Common";

//비밀번호 찾기
const CertificationMobile = ({varMobile,setMobile,onChangeInputHandler}) => {
  //휴대폰 인증관련 메뉴 표시 유무
  const [varShowMobile,setShowMobile] = useState(false);

  //인증절차
  const onSendCertificationHandler = () => {
    if(varMobile.mem_mobile === "") {
      alert('인증할 휴대폰번호를 먼저 입력하세요.'); return false;
    }

    //인증코드 생성 및 발송
    const certCode = randomStringOnlyNumber(4);
    setMobile({...varMobile,mem_certcode:certCode});
    //console.log(certCode);
    sendMessageToMobile(varMobile.mem_mobile,certCode);
    setShowMobile(true);
  }
  //인증코드 입력후 검증
  const onCheckCertificationHandler = () => {
    if(varMobile.mem_certcode === "") {
      alert('도착한 인증코드를 먼저 입력하세요.'); return false;
    }
    if(varMobile.mem_certcode !== varMobile.mem_cert) {
      alert('입력한 코드가 발송한 인증코드와 일치하지 않습니다. 확인후 다시 입력하세요.'); 
      //인증코드부분 초기화
      setMobile({...varMobile,mem_cert:""});
      return false;
    }
    //인증완성
    setMobile({...varMobile,chk_mobile:true});
    setShowMobile(false); //인증부분 감추기
    alert('휴대폰 본인인증이 되었습니다.');
  }

  return (
    <div className="form-group mb50">
      <label className="form-label">휴대폰 번호 <font style={{color:"red"}}>*</font></label>
      <div className="field-group mb10">
        <input type="text" name="mem_mobile" value={ChangeMobileFormat(varMobile.mem_mobile||"")} placeholder="휴대폰 번호를 입력하세요." className="form-control" onChange={onChangeInputHandler}/>
        <button className="form-control-btn" onClick={onSendCertificationHandler}>인증하기</button>
      </div>
      <div className="field-group" style={varShowMobile?{display:""}:{display:"none"}}>
        <input type="text" name="mem_cert" value={varMobile.mem_cert||""} placeholder="인증 번호를 입력하세요." className="form-control" onChange={onChangeInputHandler} />
        <button className="form-control-btn active" onClick={onCheckCertificationHandler}>확인</button>
      </div>
    </div>
  );
}
export default CertificationMobile;